import VisaoGeral from "./VisaoGeral";

export default function Extratos() {
  return <VisaoGeral />;
}
